export const ANIMATION_TIME = 100;
export const GROUP_ID_CSS_PREFIX = "group-id-";
export const MIN_INTERSTITIAL_TICKS = 7;
export const MAX_FULL_TICKS = 11;
export const BAR_HEIGHT = 20;
export const DATE_BAR_COLORS = [
  "181, 222, 246",
  "177, 233, 200",
  "227, 169, 249",
  "255, 187, 211",
  "253, 154, 154",
  "252, 199, 99",
  "255, 244, 210"
];
